import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import "semantic-ui-css/semantic.min.css";
import { ConnectedRouter } from "connected-react-router";
import configureStore, { history } from "store";

import App from "containers/App";

import { loadIntlMessages } from "utils";
import APITokenPersistence from "./components/APITokenPersistence";
import { SearchProvider } from "./containers/providers/SearchProvider";
import { PermissionsProvider } from "./containers/contexts/PermissionsContext";

// create the redux store with middlewares, e.g. redux-saga.
const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <APITokenPersistence>
      <IntlProvider {...loadIntlMessages()}>
        <PermissionsProvider>
          <ConnectedRouter history={history}>
            <SearchProvider>
              <App />
            </SearchProvider>
          </ConnectedRouter>
        </PermissionsProvider>
      </IntlProvider>
    </APITokenPersistence>
  </Provider>,
  document.getElementById("root")
);

if (window.Cypress) {
  window.store = store;
}
